/* [BD] Scroll-reveal text — bd-scrolling-text, bd-studies-slider, bd-fish-oils (data-bd-scroll-text) */
;(function () {
  function wrapBdScrollingTextWords(container) {
    if (!container) return [];
    if (container.getAttribute('data-bd-st-wrapped') === '1') {
      return container.querySelectorAll('.bd-scroll-text__word');
    }

    var walk = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walk.nextNode())) {
      if (!node.nodeValue || !/\S/.test(node.nodeValue)) continue;
      var parent = node.parentNode;
      if (!parent || (parent.closest && parent.closest('script, style, noscript'))) continue;
      textNodes.push(node);
    }

    var anyWord = false;
    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var re = /(\s+)|(\S+)/g;
      var m;
      var replaced = false;
      while ((m = re.exec(text)) !== null) {
        if (m[1]) {
          frag.appendChild(document.createTextNode(m[1]));
        } else if (m[2]) {
          replaced = true;
          anyWord = true;
          var span = document.createElement('span');
          span.className = 'bd-scroll-text__word';
          span.appendChild(document.createTextNode(m[2]));
          frag.appendChild(span);
        }
      }
      if (replaced && textNode.parentNode) {
        textNode.parentNode.replaceChild(frag, textNode);
      }
    });

    if (anyWord) container.setAttribute('data-bd-st-wrapped', '1');
    return container.querySelectorAll('.bd-scroll-text__word');
  }

  function bdScrollingTextProgress(section) {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    var startOffset = vh * 0.88;
    var travel = Math.max(rect.height + vh * 0.5, 1);
    return Math.max(0, Math.min(1, (startOffset - rect.top) / travel));
  }

  function bdScrollingTextProgressRoot(section, content) {
    if (section.getAttribute('data-bd-studies-slider') != null) {
      var slide = content.closest('.bd-studies-slider__slide');
      if (slide) return slide;
    }
    return section;
  }

  function initBdScrollingText(scope) {
    var roots = (scope || document).querySelectorAll('[data-bd-scroll-text]');
    if (!roots.length) return;
    roots.forEach(function (section) {
      if (!section || section.getAttribute('data-bd-st-init') === '1') return;
      var contents = section.querySelectorAll('[data-bd-scroll-text-content]');
      if (!contents.length) return;

      var bundles = [];
      contents.forEach(function (content) {
        var words = wrapBdScrollingTextWords(content);
        if (!words.length) return;
        bundles.push({
          words: words,
          progressRoot: bdScrollingTextProgressRoot(section, content),
        });
      });
      if (!bundles.length) return;

      section.setAttribute('data-bd-st-init', '1');

      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function apply() {
        if (reduce) {
          bundles.forEach(function (b) {
            Array.prototype.forEach.call(b.words, function (w) {
              w.classList.add('is-active');
            });
          });
          return;
        }
        bundles.forEach(function (b) {
          var p = bdScrollingTextProgress(b.progressRoot);
          var threshold = p * b.words.length;
          Array.prototype.forEach.call(b.words, function (w, i) {
            w.classList.toggle('is-active', i < threshold);
          });
        });
      }

      var tickScheduled = false;
      function onScroll() {
        if (tickScheduled) return;
        tickScheduled = true;
        requestAnimationFrame(function () {
          tickScheduled = false;
          apply();
        });
      }

      apply();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  }

  function boot(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    initBdScrollingText(root);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionScrollTextDesignMode) {
    window.__bdSectionScrollTextDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
